export default __webpack_public_path__ + "static/annRobert-324005648ef719e21475f8dfde7bdf0a.png";